<template>
  <div>
    <cargo-crud-checklist-id
      :model="model"
      :modelstate="modelstate"
      :readonly="readonly"
    >
    </cargo-crud-checklist-id>
  </div>
</template>

<script>
import AwesomeMask from "awesome-mask";
import CargoCrudChecklistId from '../CargoCrudChecklistId.vue';

export default {
  components: { CargoCrudChecklistId },
  name: "CargoCrudData",
  directives: {
    mask: AwesomeMask,
  },
  props: {
    model: Object,
    modelstate: Object,
    readonly: Boolean,
  },
};
</script>
